var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 180,
    viewBox: "0 0 1920 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 180L80 150C160 120 320 60 480 36C640 12 800 24 960 54C1120 84 1280 132 1440 126C1600 120 1760 60 1840 30L1920 0H1840C1760 0 1600 0 1440 0C1280 0 1120 0 960 0C800 0 640 0 480 0C320 0 160 0 80 0H0V180Z",
    fill: "#FFE8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowDown);
export default __webpack_public_path__ + "static/media/shadow-down.8b09450512bbf95a6c362f813f13d7e1.svg";
export { ForwardRef as ReactComponent };